import { stringify } from "qs";
import {
  InvoiceSourceSyncList,
  InvoiceSourceSyncStatus,
} from "types/Models/invoiceSourceSync";
import { emptyApi } from "./emptyApi";

const INVOICE_SYNC_INVALIDATIONS = [
  "INVOICE_SOURCE_SYNC",
  "INVOICES",
  "GENERAL_LEDGER",
  "LIVE_REPORT",
  "JOURNAL_ENTRIES",
  "AUDIT_LOG_BY_OBJECT",
] as const;

export const invoiceSourceSyncApis = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getInvoiceSourceSync: build.query<
      InvoiceSourceSyncList,
      {
        entityId: string;
        syncStatuses?: InvoiceSourceSyncStatus[];
        pageNum?: number;
        limit?: number;
      }
    >({
      query: ({ entityId, syncStatuses, pageNum, limit }) => {
        const query = stringify(
          {
            sync_statuses: syncStatuses?.join(","),
            page_num: pageNum,
            limit,
          },
          { skipNulls: true }
        );
        return {
          url: `/api/inkle/invoicing/entity/${entityId}/invoice-source-sync/?${query}`,
        };
      },
      providesTags: ["INVOICE_SOURCE_SYNC"],
    }),

    bulkResyncSourceChangedInvoices: build.mutation<
      { queued: number },
      { entityId: string }
    >({
      query: ({ entityId }) => ({
        url: `/api/inkle/invoicing/entity/${entityId}/invoice-source-sync/resync/`,
        method: "POST",
      }),
      invalidatesTags: [...INVOICE_SYNC_INVALIDATIONS],
    }),
  }),
});

export const {
  useGetInvoiceSourceSyncQuery,
  useBulkResyncSourceChangedInvoicesMutation,
} = invoiceSourceSyncApis;
